import React, { useState, useRef, useEffect } from 'react';
import { Carousel, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from './ProductList.module.scss';
import ProductItem from './ProductItem';
import { useAppSelector } from '@/store/hooks';
import { getProductBrandAllList,getProductCategoryShowList } from '@/api/products';

// import icon1 from '@/assets/images/组 2233@2x.png';
// import icon2 from '@/assets/images/组 2234@2x.png';
// import icon3 from '@/assets/images/组 2235@2x.png';
// import icon4 from '@/assets/images/组 2236@2x.png';
// import icon5 from '@/assets/images/组 2237@2x.png';
// import icon6 from '@/assets/images/组 2238@2x.png';
// import icon7 from '@/assets/images/组 2241@2x.png';




interface ProductListProps {
  goodsList: any[];
  getType?: (str: number) => void; // 可选的回调函数
  isShowTop?: boolean;

}

interface ITopList {
  product_category_id: number;
  product_category_name: string;
}

const ProductList: React.FC<ProductListProps> = ({ getType, goodsList, isShowTop = true }) => {
  const classificationText = useAppSelector((state) => state.searchBar.classificationText);
  //获取dom
  const scrollRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  //分类列表
  const [topList, setTopList] = useState<ITopList[]>([
    // {
    //   product_category_id: 1,
    //   product_category_name: 'Mobile Phone'
    // },
   
  ]);

  const [topIdex, setTopIdex] = useState(-1);

  //切换类型并把数据传给父组件
  const changeType = (index: number, type: number) => {
    setTopIdex(index);
    getType && getType(type);

    navigate(`/searchList?product_category_id=${type}&&activeTabIndex=0`);
  }



  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollAmount = 200; // 每次滚动的距离
      scrollRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth' // 平滑滚动
      });
    }
  };

  //classificationText分类的监听
  useEffect(() => {
    //console.log('home组件classificationText6666', classificationText);
    if (classificationText.product_category_id) {
      getProductBrandAllList({
        product_category_id: classificationText.product_category_id
      }).then((res) => {
        if (res.code == 200) {
          // setTopList(res.data);
        }
      })
    }


  }, [classificationText]);

  useEffect(() => {
    getProductCategoryShowList().then((res) => {
      if (res.code == 200) {
        setTopList(res.data);
      }
    })
  }, []);

  return (
    <div className={styles['list-box']}>
      {
        isShowTop &&
        <div className={styles['top-box']}>
          <div className={styles['top-big-item']} style={{width: '100%'}} ref={scrollRef}>
            {
              topList.map((item, index) => (
                <div
                  className={styles['top-small-item']}
                  key={index}
                  onClick={() => changeType(index, item.product_category_id)}
                >
                  <span
                    className={`${index === topIdex ? styles['span-active'] : ''}`}
                  >{item.product_category_name}</span>
                </div>
              ))
            }

          </div>
          {/* <div className={styles['top-btn']} onClick={handleScroll}>{'>'}</div> */}
        </div>
      }


      <div className={styles['product-box']}>
        {
          goodsList.map((item, index) => (
            <ProductItem item={item} key={index} />
          ))
        }
      </div>
    </div>
  );
};

export default ProductList; 